const env = (import.meta as any).env

export default {
  ENVIRONMENT: env.SFC_ENV,
  API_BASE_URL: env.SFC_API_BASE_URL,
  AZURE_CLIENT_ID: env.SFC_AZURE_CLIENT_ID,
  AZURE_TENANT_ID: env.SFC_AZURE_TENANT_ID,
}
